import React from 'react';
import SwipeableViews from 'react-swipeable-views';
import { withStyles } from '@material-ui/core/styles';
import { withTranslation } from 'react-i18next';
import AppBar from '@material-ui/core/AppBar';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import Typography from '@material-ui/core/Typography';
import ParentLoginPage from './non-logged/ParentLoginPage';
import StudentLoginPage from './non-logged/StudentLoginPage';
import ParentSignupPage from './non-logged/ParentSignupPage';
import ErrorBoundary from './parts/Error/ErrorBoundary';

function TabContainer({ children }) {
  return (
    <Typography component="div" style={{ padding: 8 * 3 }}>
      {children}
    </Typography>
  );
}

const styles = () => ({
  appBar: {
    color: '#000',
    backgroundColor: '#fff',
    boxShadow: 'none',
    borderBottom: '1px solid #eee',
  },
  content: {
    padding: 32,
  },
});

class MobileNonLoggedPage extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      tabIndex: 0,
    };

    this.onChange = this.onChange.bind(this);
    this.onChangeIndex = this.onChangeIndex.bind(this);
  }

  onChange(event, tabIndex) {
    this.setState({ tabIndex });
  }

  onChangeIndex(event, tabIndex) {
    this.setState({ tabIndex });
  }

  render() {
    const {
      tabIndex,
    } = this.state;
    const {
      classes,
      t,
    } = this.props;

    return (
      <ErrorBoundary location="MobileNonLoggedPage.js">
        {appType === 'parent'
          && (
          <div>
            <AppBar
              position="static"
              className={classes.appBar}
            >
              <Tabs
                value={tabIndex}
                onChange={this.onChange}
                centered
              >
                <Tab label={t('Log In')} />
                <Tab label={t('Sign Up')} />
              </Tabs>
            </AppBar>
            <SwipeableViews
              index={tabIndex}
              onChangeIndex={this.onChangeIndex}
              enableMouseEvents
            >
              <TabContainer>
                <ParentLoginPage useSuspense={false} />
              </TabContainer>
              <TabContainer>
                <ParentSignupPage useSuspense={false} />
              </TabContainer>
            </SwipeableViews>
          </div>
          )
        }
        {appType === 'student'
          && (
          <div>
            <TabContainer>
              <StudentLoginPage useSuspense={false} />
            </TabContainer>
          </div>
          )
        }
      </ErrorBoundary>
    );
  }
}

export default withStyles(styles)(withTranslation()(MobileNonLoggedPage));
